import { useEffect, useRef, useState } from 'react';

import getScrollPosition from 'src/utils/getScrollPosition';

export const usePageTabs = (): { isStickyOnDesktop: boolean } => {
  const [isStickyOnDesktop, setIsStickyOnDesktop] = useState(false);

  // https://stackoverflow.com/questions/57088861/react-setstate-hook-from-scroll-event-listener
  const prevScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = getScrollPosition();

      // This -12 offsets the PageTabs from flicking in and out of stickiness when scrolling up or down by a small amount
      const currentScrollY = isStickyOnDesktop
        ? scrollPosition - 12
        : scrollPosition;

      if (prevScrollY.current < currentScrollY && isStickyOnDesktop) {
        setIsStickyOnDesktop(false);
      } else if (prevScrollY.current > currentScrollY && !isStickyOnDesktop) {
        setIsStickyOnDesktop(true);
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isStickyOnDesktop, setIsStickyOnDesktop]);

  return {
    isStickyOnDesktop,
  };
};
